DialogListasPublicaCtrl.$inject = ['$log', '$scope', '$http', '$q'];

export default function DialogListasPublicaCtrl($log, $scope, $http, $q) {
    var lp = this;

    lp.listaId = $scope.model.listaId;
    lp.esPublica = $scope.model.esPublica;

    lp.dialogHandler = $scope.dialog;

    lp.cargando = false;

    var urlBase = Sigo.var.path + '/api/v1/listas-acciones/' + lp.listaId;

    var promesaPublica = null;
    lp.cambiaPublica = cambiaPublica;

    function cambiaPublica() {
        if (!lp.cargando) {
            lp.cargando = true;
            var data = {'es_publica': !lp.esPublica};
            promesaPublica = $http.put(urlBase, data);
            promesaPublica.then(function (respuesta) {
                lp.cargando = false;
                lp.dialogHandler.close(respuesta);
            }, function (err) {
                $log.error('Error');
                lp.cargando = false;
                lp.cerrar();
                respuestaErronea(err);
            });
            return promesaPublica;
        }
        return promesaPublica;
    }

    lp.cerrar = function () {
        lp.dialogHandler.cancel();
    }

}